import React from 'react';
import type { CatalogEntry } from '../../services/inferenceApi';
import ProviderBadge from './ProviderBadge';

interface CompareTrayProps {
  models: CatalogEntry[];
  selection: string[];
  onRemove: (id: string) => void;
  onCompare: () => void;
  onClear: () => void;
}

export default function CompareTray({ models, selection, onRemove, onCompare, onClear }: CompareTrayProps) {
  if (selection.length === 0) return null;
  const chips = selection
    .map((id) => models.find((m) => m.id === id))
    .filter((m): m is CatalogEntry => Boolean(m));
  return (
    <div className="fixed bottom-4 inset-x-0 z-[45] flex justify-center px-4 pr-24 sm:pr-4 pointer-events-none">
      <div className="pointer-events-auto flex flex-wrap items-center justify-center gap-3 rounded-[14px] border border-ps-accent-line bg-[#140C06] px-4 py-3 shadow-xl shadow-black/60 animate-[trayIn_.2s_ease-out] motion-reduce:animate-none">
        {chips.map((m, i) => (
          <React.Fragment key={m.id}>
            {i === 1 && <span className="text-[11px] uppercase tracking-[0.06em] text-ps-subtle">vs</span>}
            <span className="flex items-center gap-1.5 text-[13px] text-ps-text">
              <ProviderBadge name={m.provider} logoUrl={m.provider_logo_url} size={18} />
              <span className="max-w-32 truncate">{m.display_name}</span>
              <button aria-label={`Remove ${m.display_name} from compare`} onClick={() => onRemove(m.id)}
                className="px-1 text-ps-subtle hover:text-ps-text">×</button>
            </span>
          </React.Fragment>
        ))}
        {selection.length === 1 && <span className="text-xs text-ps-subtle">Pick one more to compare</span>}
        <button onClick={onClear} aria-label="Clear comparison" className="ps-cb">Clear</button>
        <button onClick={onCompare} disabled={selection.length < 2} className="ps-btn ps-btn-sm disabled:opacity-40">
          Compare
        </button>
      </div>
    </div>
  );
}
